/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const ClockOutlineIcon = /*#__PURE__*/ createSvgIcon(
  'ClockOutlineIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M10.75 9.375V5.75a.728.728 0 00-.214-.534.72.72 0 00-.532-.216.734.734 0 00-.535.216.72.72 0 00-.219.534v3.938c0 .11.02.211.063.302.041.09.097.17.166.24l2.789 2.788a.698.698 0 00.534.222.769.769 0 00.531-.24.73.73 0 00-.007-1.068L10.75 9.375zM10 18a7.787 7.787 0 01-3.108-.625 8.076 8.076 0 01-2.548-1.719 8.065 8.065 0 01-1.719-2.551A7.819 7.819 0 012 9.99a7.941 7.941 0 012.344-5.657 8.155 8.155 0 012.551-1.708A7.819 7.819 0 0110.01 2c1.104 0 2.143.21 3.115.63.972.42 1.818.99 2.537 1.71a8.08 8.08 0 011.709 2.54c.42.973.629 2.013.629 3.12a7.787 7.787 0 01-.625 3.108 8.164 8.164 0 01-1.708 2.548 7.934 7.934 0 01-2.545 1.719A7.854 7.854 0 0110 18zm.01-1.5c1.798 0 3.33-.635 4.594-1.906 1.264-1.271 1.896-2.806 1.896-4.604s-.632-3.33-1.896-4.594C13.339 4.132 11.808 3.5 10.01 3.5c-1.798 0-3.333.632-4.604 1.896C4.136 6.661 3.5 8.192 3.5 9.99c0 1.798.635 3.333 1.906 4.604 1.271 1.27 2.806 1.906 4.604 1.906z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default ClockOutlineIcon;
